import {connect} from 'react-redux';
import {itemsFetchMonth} from "../actions/monthitems";
import getSortedItems from '../selectors/items';
import getLocationItems from '../selectors/locations';
import getSortedInverters from '../selectors/inverters';
import groupedItems from '../selectors/groupeditems';
import ItemBlock from './ItemBlock';
import ItemMonthStat from './ItemMonthStat';
import FilterNav from './FilterNav';
import {getMonthRange, setPerformance} from '../util/util';
import React, {Component} from 'react';
import {Button, Modal, Popconfirm} from 'antd';
import './../index.css';
import {showPeriod} from "../actions/filters";

class ItemList extends Component {

    constructor(props) {
        super(props);
        this.showModal = this.showModal.bind(this);
        this.state = {
            showItemInModal: 0,
            itemModalName: '',
            modalVisible: false
        };
    }

    componentDidMount() {
        this.props.dispatch(showPeriod('yesterday'));
        this.props.dispatch(itemsFetchMonth());
    }

    showModal = (e) => {
        const showItemId = parseInt(e.target.id,10);
        const showItemName = e.target.name;
        if (showItemId)
            this.setState({
                showItemInModal: showItemId,
                itemModalName: showItemName,
                modalVisible: true
            });
    }

    getItemBlocks = () => {
        /*

        locations: getSortedItems(items.locations ? [...items.locations] : []),
        groupedLocations: groupedItems(items.locations ? [...items.locations] : []),
        inverters: getSortedInverters(items.inverters ? [...items.inverters] : []),
        groupedInverters: groupedInverters(items.inverters ? [...items.inverters] : []),
         */
        const {filters, data} = this.props;

        let targetData = getSortedInverters(data);
        if(!filters.showInverters)
            targetData = getSortedItems(getLocationItems(data));

        targetData = setPerformance(targetData);
        if (filters.showGrouped) {
            return (
                groupedItems(targetData).map((blockitems, ndx) => (
                    <ItemBlock key={ndx} items={blockitems} showModal={this.showModal} name={blockitems[0].location}/>
                ))
            );
        }
        return (
            <ItemBlock items={targetData} showModal={this.showModal}/>
        );
    }

    handleCancel = () => {
        this.setState({modalVisible: false});
    }

    resetBenchmark = () => {
        this.props.dispatch({type: "CLEAR_MONTH_ITEMS"});
        setTimeout(() => {
            window.location.reload();
        },1000);
    }

    render() {
        const {hasErrored, isLoading} = this.props;

        const {showItemInModal, itemModalName, modalVisible} = this.state;

        const modalTitle = `${showItemInModal} ${itemModalName} ${getMonthRange()}`;

        if (hasErrored) {
            return <p>Sorry! There was an error loading the items</p>;
        }
        if (isLoading) {
            return <p>Loading…</p>;
        }

        return (
            <div>
                <FilterNav/>
                {this.getItemBlocks()}
                {
                    modalVisible ?
                    (
                        <Modal
                            title={modalTitle}
                            width={800}
                            height={800}
                            visible={true}
                            onCancel={this.handleCancel}
                            footer={null}
                        >
                            <ItemMonthStat itemId={showItemInModal}/>
                        </Modal>
                    ) : ''
                }
                <div>
                    <Popconfirm placement="top" title={"Voer dit alleen uit als de benchmark klaar is met laden. Wacht zo nodig 1 minuut na het laden van deze pagina"} onConfirm={this.resetBenchmark} okText="Ja" cancelText="Nee">
                        <Button>Benchmark cache legen</Button>
                    </Popconfirm>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({items, filters}) => {

    return {
        hasErrored: items.hasErrored,
        isLoading: items.isLoading,
        filters: filters,
        data: items.data || [],
    };
};

export default connect(mapStateToProps)(ItemList);



// WEBPACK FOOTER //
// ./src/components/ItemList.js